import React from 'react';
import { ROUTES } from '../../routes';

export const SiteFooter: React.FC = () => (
  <footer>
    {/* Three-column panel */}
    <div
      style={{
        background: 'var(--panel)',
        padding: '40px 48px',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '32px',
      }}
    >
      {/* Column 1 */}
      <div>
        <p
          style={{
            color: 'var(--navy)',
            textTransform: 'uppercase',
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: '1.5px',
            marginBottom: 12,
          }}
        >
          GeoFluid DataHub
        </p>
        <p style={{ color: 'var(--ink)', fontSize: 13, lineHeight: 1.6 }}>
          Dept. of Earth Sciences
          <br />
          University of Oxford
        </p>
      </div>

      {/* Column 2 */}
      <div>
        <p
          style={{
            color: 'var(--navy)',
            textTransform: 'uppercase',
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: '1.5px',
            marginBottom: 12,
          }}
        >
          Explore
        </p>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <li><a href={ROUTES.DATA} style={{ color: 'var(--blue)', textDecoration: 'none', fontSize: 13 }}>Database</a></li>
          <li><a href={ROUTES.PDGEOTHERMAL} style={{ color: 'var(--blue)', textDecoration: 'none', fontSize: 13 }}>Visual Aid</a></li>
          <li><a href={ROUTES.REFERENCES} style={{ color: 'var(--blue)', textDecoration: 'none', fontSize: 13 }}>References</a></li>
        </ul>
      </div>

      {/* Column 3 */}
      <div>
        <p
          style={{
            color: 'var(--navy)',
            textTransform: 'uppercase',
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: '1.5px',
            marginBottom: 12,
          }}
        >
          Connect
        </p>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <li><a href={ROUTES.CONTRIBUTE} style={{ color: 'var(--blue)', textDecoration: 'none', fontSize: 13 }}>Contribute</a></li>
          <li><a href={ROUTES.CONTRIBUTE} style={{ color: 'var(--blue)', textDecoration: 'none', fontSize: 13 }}>Contact</a></li>
        </ul>
      </div>
    </div>

    {/* Navy sub-bar */}
    <div
      style={{
        background: 'var(--navy)',
        padding: '12px 48px',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.75)',
        fontSize: 12,
      }}
    >
      &copy; GeoFluid DataHub &middot; University of Oxford
    </div>
  </footer>
);
